module.exports = __webpack_public_path__ + "img/nthu.6a2d7d9d.png";